module.exports = __webpack_public_path__ + "img/70ne.8b1f0014.svg";